import axios from 'axios';
import errorHandlerFactory from './errorHandler';

const errorHandler = errorHandlerFactory('An error occured when trying fetching impact ananlysis ID list.');

// eslint-disable-next-line import/prefer-default-export
export const getImpactAnalysisIdList = (fromDate, toDate, username) => axios.get('/CsaImpact/GetCsaImpactIdByUsernameAndDate', { params: { fromDate, toDate, username } })
    .then(r => r.data).catch(errorHandler);
